import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SidenavService } from '../services/sidenav.service';




@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class TopBarComponent implements OnInit {

  constructor(
    private sidenav: SidenavService, private router: Router) { }

  toggleRightSidenav() {
    this.sidenav.toggle();
  }

  ngOnInit() {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {




        if (e.url == '/app-login' || e.url == '/app-register') {
          // this.inlrPages = true;
        } else {
          // //console.log('set curr url to :'+e.url);
          sessionStorage.setItem('current_url', e.url);
          // this.inlrPages = false;
        }
      }
    });

  }



}


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/